var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FileConfigWizard',{attrs:{"filelist":_vm.filelist,"backlink":"/tds/filelist"}})
}
var staticRenderFns = []

export { render, staticRenderFns }